import { parentElementUntil } from '../../jsCore/utils/dom'
import publicPdo from '../../jsCore/application/pageDataObject'

export function getAnalyticsPageType(optionalPageTypes = {}) {
  const analyticsPageType = Object.assign(
    {
      homepage: 'Home page',
      post: 'Article page',
      video_page: 'Video page', // eslint-disable-line camelcase
      hubs: 'Partner page',
    },
    optionalPageTypes
  )

  return analyticsPageType[publicPdo.getPageType()] || 'cant get pagetype from pdo'
}

export function getVideoPostWrapperName(playerRef) {
  const analyticsWrappersDescription = {
    'post-cover': 'cover',
    'post-body-wrap': 'body',
  }

  const articleSectionVideoWrapper = parentElementUntil(ancestorWrapper => {
    return (
      ancestorWrapper.classList.contains('post-cover') ||
      ancestorWrapper.classList.contains('post-body-wrap')
    )
  })

  const postAncestorNode = articleSectionVideoWrapper(playerRef)
  let wrapperName = 'no wrapper'

  return postAncestorNode
    ? Object.keys(analyticsWrappersDescription).reduce((acc, currentValue) => {
        return postAncestorNode.classList.contains(currentValue)
          ? analyticsWrappersDescription[currentValue]
          : acc
      }, wrapperName)
    : wrapperName
}

export function calculateVideoTimePercent(duration, currentTime) {
  const videoPercentageStops = [5, 25, 50, 75, 90]
  let computedVideoStepPercentage = Math.round(currentTime / (duration / 100))

  return videoPercentageStops.indexOf(computedVideoStepPercentage) !== -1
    ? computedVideoStepPercentage
    : false
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/video.js